import { TRAM } from "./lo-trinh.js";

/**
 * Màu từng trạm, dùng chung cho /cong-cu và /lo-trinh (ô trong khung xanh,
 * chip lọc, biểu tượng trên thẻ). Thứ tự theo TRAM: phần tử đầu là Điểm xuất phát.
 */
export const MAU_TRAM = ["#f4a623", "#86cfaa", "#9fb7e0", "#e9a48e", "#c3b1e6", "#7fc4c9"];

export const mauCuaTram = (tram) => {
  const i = TRAM.indexOf(tram);
  return MAU_TRAM[(i < 0 ? 0 : i) % MAU_TRAM.length];
};
